import React from 'react';

/**
 * Empty State for the Detail View
 */

const EmptyPostDetail = () => {
  const contentStyle = {
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    textAlign: 'center',
    position: 'absolute',
  };

  const tipStyles = {
    marginTop: '2rem',
    fontSize: '.85rem',
    fontStyle: 'italic',
  };

  return (
    <div
      style={{
        color: 'var(--text-color-1)',
        width: '100%',
        height: '100%',
        position: 'absolute',
      }}
    >
      <div style={contentStyle}>
        <div style={{ marginBlockEnd: '4rem', color: 'var(--text-color-2)' }}>
          Satelite
        </div>
        No Post Selected
        <p style={tipStyles}>
          Tip: Press <kbd>F</kbd> for keyboard shortcuts
        </p>
      </div>
    </div>
  );
};

export default EmptyPostDetail;
